import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-mobile-preview',
  templateUrl: './mobile-preview.component.html',
  styleUrls: ['./mobile-preview.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class MobilePreviewComponent {}
